import * as vehiclesActions from '../actions/vehicles.actions';
import { VehicleApiModel } from 'app/models/vehicle-api.model';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  vehicles: VehicleApiModel[];
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
  totalVehicles: number;
}

export const initialState: State = {
  vehicles: [],
  isLoading: false,
  isReady: false,
  isSaving: false,
  totalVehicles: 0,
};

const featureReducer = createReducer(
  initialState,
  on(vehiclesActions.loadVehicles, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(vehiclesActions.loadVehiclesSuccess, (state: State, { response }) => {
    const vehicleItems = response.results;
    const totalVehicles = response.count ? response.count : vehicleItems.length;

    return {
      ...state,
      isLoading: false,
      isReady: true,
      vehicles: vehicleItems,
      totalVehicles,
    };
  }),
  on(vehiclesActions.createVehicle, vehiclesActions.updateVehicle, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    vehiclesActions.createVehicleSuccess,
    vehiclesActions.createVehicleFailed,
    vehiclesActions.updateVehicleSuccess,
    vehiclesActions.updateVehicleFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    vehiclesActions.resetVehicles,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
